<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        @if (loading) {
            <p class="state-text">Loading…</p>
        } @else {
            <form class="account-card" [class.shake]="shake" (ngSubmit)="save()" novalidate>
                <h2 class="card-title">Account details</h2>

                <div class="field">
                    <label>Username</label>
                    <input class="input readonly" type="text" [value]="username" readonly />
                </div>

                @if (isLocal) {
                    <div class="field">
                        <label>Email</label>
                        <input class="input" [class.invalid]="emailInvalid" type="email" name="email"
                            [(ngModel)]="email" (ngModelChange)="emailInvalid = false" autocomplete="off" />
                        @if (emailInvalid) {
                            <span class="err">Please enter a valid email.</span>
                        }
                    </div>

                    <div class="field">
                        <label>Name</label>
                        <input class="input" type="text" name="name" [(ngModel)]="name" autocomplete="off" />
                    </div>

                    <div class="field">
                        <label>Mobile</label>
                        <input class="input" type="text" name="mobile" [(ngModel)]="mobile" autocomplete="off" />
                    </div>
                }

                <div class="divider"></div>
                @if (isLocal) {
                    <p class="hint">Leave the password fields blank to keep your current password.</p>
                } @else {
                    <p class="hint">Your password is managed by the FYES cloud. Enter a new one to change it.</p>
                }

                <div class="field">
                    <label>{{ isLocal ? 'New password' : 'Password' }}</label>
                    <input class="input" [class.invalid]="passwordMismatch" type="password" name="password"
                        [(ngModel)]="password" (ngModelChange)="passwordMismatch = false"
                        autocomplete="new-password" />
                </div>

                <div class="field">
                    <label>Confirm password</label>
                    <input class="input" [class.invalid]="passwordMismatch" type="password" name="passwordConfirm"
                        [(ngModel)]="passwordConfirm" (ngModelChange)="passwordMismatch = false"
                        autocomplete="new-password" />
                    @if (passwordMismatch) {
                        <span class="err">Passwords do not match.</span>
                    }
                </div>

                <div class="actions">
                    <button class="save-btn" type="submit" [disabled]="saving">
                        {{ saving ? 'Saving…' : (isLocal ? 'Save changes' : 'Change password') }}
                    </button>
                </div>
            </form>
        }
    </div>
</div>

<app-footer></app-footer>
